import { convertToNative } from "./convertToNative";
export var unmarshall = function unmarshall(data, options) {
  return convertToNative({
    M: data
  }, options);
};